/**
 * Platform detection utilities
 */

/**
 * Detects if the current device is running iOS
 * @returns boolean indicating if running on iOS
 */
export const isIOS = (): boolean => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent) || 
    (userAgent.includes('mac') && 'ontouchend' in document);
};

/**
 * Checks if BarcodeDetector API is supported on the device
 * @returns boolean indicating if BarcodeDetector is supported
 */
export const isBarcodeDetectorSupported = (): boolean => {
  return typeof window !== 'undefined' && 'BarcodeDetector' in window;
};

/**
 * Type definition for storage keys
 */
export type StorageKeys = {
  BARCODE_SCANNER_ACTIVE: string;
};

/**
 * Constants for local storage keys
 */
export const STORAGE_KEYS: StorageKeys = {
  BARCODE_SCANNER_ACTIVE: 'barcodeScanner.active'
};

/**
 * Saves barcode scanner active state to localStorage
 * @param isActive boolean representing if barcode scanner is active
 */
export const saveScannerState = (isActive: boolean): void => {
  try {
    localStorage.setItem(STORAGE_KEYS.BARCODE_SCANNER_ACTIVE, isActive ? 'true' : 'false');
  } catch (error) {
    console.error('Failed to save scanner state to localStorage:', error);
  }
};

/**
 * Retrieves barcode scanner active state from localStorage
 * @returns boolean indicating if barcode scanner was active in previous session
 */
export const getSavedScannerState = (): boolean => {
  try {
    const savedState = localStorage.getItem(STORAGE_KEYS.BARCODE_SCANNER_ACTIVE);
    return savedState === 'true';
  } catch (error) {
    console.error('Failed to retrieve scanner state from localStorage:', error);
    return false;
  }
}; 